import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';
import { en } from './locales/en';
import { ru } from './locales/ru';

void i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      ru: { translation: ru },
      en: { translation: en },
    },
    fallbackLng: 'ru',
    supportedLngs: ['ru', 'en'],
    interpolation: { escapeValue: false },
    detection: {
      // `?lang=ru` — ссылки с русского лендинга (владелец 2026-10-26): гость с английским телефоном не видит смесь
      // английского интерфейса и русской истории. Выбор запоминается в lx.lang; у вошедшего язык берётся из профиля.
      order: ['querystring', 'localStorage', 'navigator'],
      lookupQuerystring: 'lang',
      caches: ['localStorage'],
      lookupLocalStorage: 'lx.lang',
    },
  });

// Держим <html lang> в синхроне с активной локалью: раньше он всегда оставался "ru",
// из-за чего скринридеры читали EN-интерфейс с русской фонетикой, а авто-перевод/SEO
// получали неверный язык страницы.
const applyHtmlLang = (lng?: string): void => {
  if (typeof document === 'undefined') return;
  document.documentElement.lang = lng?.startsWith('en') ? 'en' : 'ru';
};
applyHtmlLang(i18n.language);
i18n.on('languageChanged', applyHtmlLang);

export default i18n;
